import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Card from "@material-tailwind/react/Card";
import CardBody from "@material-tailwind/react/CardBody";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";

import {BsFileEarmarkExcelFill} from "react-icons/bs";

import {Colors} from "../../../assets/Colors";
import Spinner from "../../../components/spinner/Spinner";

import {getMonitoring, monitoringSelector} from "./monitoringSlice";
import {getMinKaryawanCuti, karyawanSelector,} from "../karyawan/karyawanSlice";

import {cutiTransaksiSelector, getSpecCuti,} from "../../../features/hrd/transaksi/cuti/cutiTransaksiSlice";
import {getSpecTiket, tiketTransaksiSelector,} from "../../../features/hrd/transaksi/tiket/tiketTransaksiSlice";
import {getSpecResign, resignTransaksiSelector,} from "../../../features/hrd/transaksi/resign/resignTransaksiSlice";
import {getSpecPhk, phkTransaksiSelector,} from "../../../features/hrd/transaksi/phk/phkTransaksiSlice";
import {
    getSpecPelatihan,
    pelatihanTransaksiSelector,
} from "../../../features/hrd/transaksi/pelatihan/pelatihanTransaksiSlice";
import {getSpecLembur, lemburTransaksiSelector,} from "../../../features/hrd/transaksi/lembur/lemburTransaksiSlice";
import {getSpecIzin, izinTransaksiSelector,} from "../../../features/hrd/transaksi/izin/izinTransaksiSlice";
import {
    claimPengobatanTransaksiSelector,
    getSpecClaimPengobatan,
} from "../../../features/hrd/transaksi/claim-pengobatan/claimPengobatanTransaksiSlice";

const MonitoringPage = ({}) => {
    const monitoring = useSelector(monitoringSelector);
    const karyawan = useSelector(karyawanSelector);
    const cuti = useSelector(cutiTransaksiSelector);
    const tiket = useSelector(tiketTransaksiSelector);
    const resign = useSelector(resignTransaksiSelector);
    const phk = useSelector(phkTransaksiSelector);
    const pelatihan = useSelector(pelatihanTransaksiSelector);
    const lembur = useSelector(lemburTransaksiSelector);
    const izin = useSelector(izinTransaksiSelector);
    const claimPengobatan = useSelector(claimPengobatanTransaksiSelector);

    const dispatch = useDispatch();
    const [searchKaryawan, setSearchKaryawan] = useState("");
    const [searchTanggalAwal, setSearchTanggalAwal] = useState("");
    const [searchTanggalAkhir, setSearchTanggalAkhir] = useState("");
    const [currentID, setCurrentID] = useState("");

    const [showModalCuti, setShowModalCuti] = useState(false);
    const [showModalTiket, setShowModalTiket] = useState(false);
    const [showModalResign, setShowModalResign] = useState(false);
    const [showModalPhk, setShowModalPhk] = useState(false);
    const [showModalPelatihan, setShowModalPelatihan] = useState(false);
    const [showModalLembur, setShowModalLembur] = useState(false);
    const [showModalIzin, setShowModalIzin] = useState(false);
    const [showModalClaimPengobatan, setShowModalClaimPengobatan] =
        useState(false);

    const [start, setStart] = useState("");
    const [count, setCount] = useState("");
    const [TanggalAwal, setTanggalAwal] = useState(
        new Date(new Date().valueOf() - 30 * 1000 * 3600 * 24)
    ); //moment - 30
    const [TanggalAkhir, setTanggalAkhir] = useState(new Date()); //moment

    useEffect(() => {
        dispatch(
            getMonitoring({
                start: start,
                count: count,
                Nik: "",
                TanggalAwal: JSON.stringify(TanggalAwal),
                TanggalAkhir: JSON.stringify(TanggalAkhir),
            })
        );
        dispatch(getMinKaryawanCuti({search: ""}));
    }, []);

    useEffect(() => {
        handleSearch();
    }, [searchKaryawan, searchTanggalAkhir, searchTanggalAwal]);

    function handleSearch() {
        let tanggalAwalValue;
        let tanggalAkhirValue;
        if (searchTanggalAwal === "" || searchTanggalAwal === null) {
            tanggalAwalValue = JSON.stringify(TanggalAwal);
        } else {
            tanggalAwalValue = JSON.stringify(searchTanggalAwal);
        }
        if (searchTanggalAkhir === "" || searchTanggalAkhir === null) {
            tanggalAkhirValue = JSON.stringify(TanggalAkhir);
        } else {
            tanggalAkhirValue = JSON.stringify(searchTanggalAkhir);
        }


        let params = {
            start: start,
            count: start,
            Nik: searchKaryawan,
            TanggalAwal: tanggalAwalValue,
            TanggalAkhir: tanggalAkhirValue,
        };
        dispatch(getMonitoring(params));
    }

    return (
        <div className="md:ml-64">
            <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                <div className="container mx-auto max-w-full">
                    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                </div>
            </div>

            <div className="px-3 md:px-8 h-auto -mt-32">
                <div className="container mx-auto max-w-full">
                    <div className="grid grid-cols-1 px-4">
                        <Card className="flex flex-col items-center content-center">
                            <>
                                <form className="flex w-full justify-around px-4 pt-2 flex-col sm:flex-row">
                                    <div
                                        className="w-full sm:w-1/3 relative text-gray-800 border rounded-md sm:mr-4"
                                        style={{color: Colors.primary}}
                                    >
                                        <select
                                            value={searchKaryawan}
                                            onChange={(e) => setSearchKaryawan(e.target.value)}
                                            name="Nik"
                                            className="w-full py-2 text-sm text-gray-800 rounded-md px-4 bg-white focus:outline-none"
                                        >
                                            <option defaultValue value="">
                                                Semua Karyawan
                                            </option>
                                            {karyawan.minDataCuti.map((item) => (
                                                <option key={item.Nik} value={item.Nik}>
                                                    {item.NamaKaryawan}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div
                                        className="w-full sm:w-1/3 relative text-gray-800 border rounded-md sm:mx-4 my-2 sm:my-0"
                                        style={{color: Colors.primary}}
                                    >
                                        <DatePicker
                                            className="w-full py-2 text-sm text-gray-800 rounded-md px-4 bg-white focus:outline-none"
                                            selected={searchTanggalAwal}
                                            onChange={(date) => {
                                                setSearchTanggalAwal(date);
                                            }}
                                            placeholderText="Tanggal Awal"
                                            isClearable={true}
                                        />
                                    </div>
                                    <div
                                        className="w-full sm:w-1/3 relative text-gray-800 border rounded-md sm:ml-4"
                                        style={{color: Colors.primary}}
                                    >
                                        <DatePicker
                                            className="w-full py-2 text-sm text-gray-800 rounded-md px-4 bg-white focus:outline-none"
                                            selected={searchTanggalAkhir}
                                            onChange={(date) => {
                                                setSearchTanggalAkhir(date);
                                            }}
                                            placeholderText="Tanggal Akhir"
                                            isClearable={true}
                                        />
                                    </div>
                                </form>

                                <CardBody className="w-full pt-0 ">
                                    <div className="overflow-x-auto">
                                        {monitoring.isMonitoringFetching ? (
                                            <Spinner/>
                                        ) : (
                                            <table className="table-auto w-full bg-transparent border-collapse">
                                                <thead>
                                                <tr>
                                                    <th
                                                        style={{color: Colors.primary}}
                                                        className="w-1/12 font-extrabold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-lg whitespace-nowrap text-left"
                                                    >
                                                        Menu
                                                    </th>
                                                    <th
                                                        style={{color: Colors.primary}}
                                                        className="w-1/12 font-extrabold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-lg whitespace-nowrap text-left"
                                                    >
                                                        Keterangan
                                                    </th>
                                                    <th
                                                        style={{color: Colors.primary}}
                                                        className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-lg whitespace-nowrap text-left"
                                                    >
                                                        Tanggal
                                                    </th>
                                                    <th
                                                        style={{color: Colors.primary}}
                                                        className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-lg whitespace-nowrap text-left"
                                                    >
                                                        Jenis
                                                    </th>
                                                    <th
                                                        style={{color: Colors.primary}}
                                                        className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-lg whitespace-nowrap text-left"
                                                    >
                                                        Status
                                                    </th>
                                                </tr>
                                                </thead>

                                                <tbody>
                                                {monitoring.data &&
                                                    monitoring.data.map((item, i) => (
                                                        <>
                                                            <tr key={i}>
                                                                <th className="border-b border-gray-200 align-middle font-bold text-sm whitespace-nowrap px-2 py-1 text-left">
                                                                    {item.Nik}
                                                                </th>
                                                                <th className="border-b border-gray-200 align-middle font-bold text-sm whitespace-nowrap px-2 py-1 text-left">
                                                                    {item.NamaKaryawan}
                                                                </th>
                                                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left"></th>
                                                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left"></th>
                                                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left"></th>
                                                            </tr>
                                                            {item.Detail &&
                                                                item.Detail.map((subitem, j) => (
                                                                    <tr
                                                                        key={i + j}
                                                                        className="cursor-pointer"
                                                                        onClick={() => {
                                                                            if (subitem.Menu === "Cuti") {
                                                                                dispatch(
                                                                                    getSpecCuti({
                                                                                        TransaksiApprovalID:
                                                                                        subitem.TransaksiID,
                                                                                    })
                                                                                );
                                                                                setCurrentID(subitem.TransaksiID);
                                                                                setShowModalCuti(true);
                                                                            }
                                                                            if (subitem.Menu === "Tiket") {
                                                                                dispatch(
                                                                                    getSpecTiket({
                                                                                        TransaksiApprovalID:
                                                                                        subitem.TransaksiID,
                                                                                    })
                                                                                );
                                                                                setCurrentID(subitem.TransaksiID);
                                                                                setShowModalTiket(true);
                                                                            }
                                                                            if (subitem.Menu === "Resign") {
                                                                                dispatch(
                                                                                    getSpecResign({
                                                                                        TransaksiApprovalID:
                                                                                        subitem.TransaksiID,
                                                                                    })
                                                                                );
                                                                                setCurrentID(subitem.TransaksiID);
                                                                                setShowModalResign(true);
                                                                            }
                                                                            if (subitem.Menu === "PHK") {
                                                                                dispatch(
                                                                                    getSpecPhk({
                                                                                        TransaksiApprovalID:
                                                                                        subitem.TransaksiID,
                                                                                    })
                                                                                );
                                                                                setCurrentID(subitem.TransaksiID);
                                                                                setShowModalPhk(true);
                                                                            }
                                                                            if (subitem.Menu === "Pelatihan") {
                                                                                dispatch(
                                                                                    getSpecPelatihan({
                                                                                        TransaksiApprovalID:
                                                                                        subitem.TransaksiID,
                                                                                    })
                                                                                );
                                                                                setCurrentID(subitem.TransaksiID);
                                                                                setShowModalPelatihan(true);
                                                                            }
                                                                            if (subitem.Menu === "Lembur") {
                                                                                dispatch(
                                                                                    getSpecLembur({
                                                                                        TransaksiApprovalID:
                                                                                        subitem.TransaksiID,
                                                                                    })
                                                                                );
                                                                                setCurrentID(subitem.TransaksiID);
                                                                                setShowModalLembur(true);
                                                                            }
                                                                            if (subitem.Menu === "Izin") {
                                                                                dispatch(
                                                                                    getSpecIzin({
                                                                                        TransaksiApprovalID:
                                                                                        subitem.TransaksiID,
                                                                                    })
                                                                                );
                                                                                setCurrentID(subitem.TransaksiID);
                                                                                setShowModalIzin(true);
                                                                            }
                                                                            if (
                                                                                subitem.Menu === "ClaimPengobatan"
                                                                            ) {
                                                                                dispatch(
                                                                                    getSpecClaimPengobatan({
                                                                                        TransaksiApprovalID:
                                                                                        subitem.TransaksiID,
                                                                                    })
                                                                                );
                                                                                setCurrentID(subitem.TransaksiID);
                                                                                setShowModalClaimPengobatan(true);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                                            {subitem.Menu}
                                                                        </th>
                                                                        <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                                            {subitem.Keterangan.split("\\n").map(
                                                                                (line, i) => (
                                                                                    <span key={"ket" + i}>
                                              {line}
                                                                                        <br/>
                                            </span>
                                                                                )
                                                                            )}
                                                                        </th>
                                                                        <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                                            {subitem.Tanggal.split("\\n").map(
                                                                                (line, i) => (
                                                                                    <span key={"tanggal" + i}>
                                              {line}
                                                                                        <br/>
                                            </span>
                                                                                )
                                                                            )}
                                                                        </th>
                                                                        <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                                            {subitem.Jenis}
                                                                        </th>
                                                                        <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                                            {subitem.Status}
                                                                        </th>
                                                                    </tr>
                                                                ))}
                                                        </>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </CardBody>
                                {!monitoring.data && !monitoring.isMonitoringFetching && (
                                    <div className="w-full flex flex-col justify-center items-center">
                                        <BsFileEarmarkExcelFill className="text-7xl py-2 text-gray-400"/>
                                        <div className="pb-4 text-gray-800">
                                            Data tidak ditemukan
                                        </div>
                                    </div>
                                )}
                            </>
                        </Card>
                    </div>
                </div>
            </div>
            {cuti.isSpecCutiSuccess && (
                <Modal
                    size="regular"
                    active={showModalCuti}
                    toggler={() => {
                        setShowModalCuti(true);
                    }}
                >
                    <ModalHeader
                        className="mt-20"
                        toggler={() => {
                            setShowModalCuti(false);
                        }}
                    >
                        Detail Cuti
                    </ModalHeader>
                    <ModalBody>
                        <form className="w-full max-w-lg">
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        NIK
                                    </label>
                                    <input
                                        value={cuti.SpecCutiData.Nik}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Nama
                                    </label>
                                    <input
                                        value={cuti.SpecCutiData.NamaKaryawan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jenis Cuti
                                    </label>
                                    <div className="inline-block relative w-full  ">
                                        <select
                                            value={cuti.SpecCutiData.JenisCuti}
                                            name="JenisCuti"
                                            disabled
                                            className="block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        >
                                            <option value={1}>Tahunan</option>
                                            <option value={2}>Hamil</option>
                                            <option value={3}>Cuti Khusus</option>
                                            <option value={4}>Cuti Bersama</option>
                                        </select>
                                        <div
                                            className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                            <svg
                                                className="fill-current h-4 w-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Keperluan Cuti
                                    </label>
                                    <input
                                        value={cuti.SpecCutiData.KeperluanCuti}
                                        name="KeperluanCuti"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        disabled
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Pengganti
                                    </label>
                                    <input
                                        value={cuti.SpecCutiData.NamaPengganti}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3">
                                <div className="w-full md:w-1/2 px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Mulai
                                    </label>
                                    <DatePicker
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        disabled
                                        selected={new Date(cuti.SpecCutiData?.TanggalMulai)}
                                    />
                                </div>

                                <div className="w-full md:w-1/2 px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Akhir
                                    </label>
                                    <DatePicker
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        disabled
                                        selected={new Date(cuti.SpecCutiData?.TanggalAkhir)}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tiket
                                    </label>
                                    <div className="inline-block relative w-full  ">
                                        <select
                                            value={cuti.SpecCutiData.Tiket}
                                            name="Tiket"
                                            disabled
                                            className={
                                                "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                        >
                                            <option value={false}>Tidak</option>
                                            <option value={true}>Iya</option>
                                        </select>
                                        <div
                                            className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                            <svg
                                                className="fill-current h-4 w-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="border-t mb-2 pt-4">Approval</div>
                            <div className="flex flex-wrap -mx-3 mb-4">
                                {
                                    cuti.SpecCutiData.Approval ?
                                        cuti.SpecCutiData.Approval.map((subitemapprov) => (
                                            <div className="w-full md:w-1/2 px-3 mb-6 h-8">
                                                <div
                                                    className="border block rounded border-gray-500 outline-none appearance-none py-3 px-4">
                                                    <div>
                                                        {subitemapprov.NamaBagian} - {subitemapprov.NamaJabatan}
                                                    </div>
                                                    <div>{subitemapprov.Approve}</div>

                                                    {subitemapprov.Approve === "Belum diApprove" ?
                                                        <div>&nbsp;</div>
                                                        :
                                                        <div>{subitemapprov.TanggalApproved}</div>
                                                    }
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div className="w-full px-3">-</div>
                                }

                            </div>
                        </form>
                    </ModalBody>
                </Modal>
            )}
            {tiket.isSpecTiketSuccess && (
                <Modal
                    size="regular"
                    active={showModalTiket}
                    toggler={() => {
                        setShowModalTiket(true);
                    }}
                >
                    <ModalHeader
                        className="mt-20"
                        toggler={() => {
                            setShowModalTiket(false);
                        }}
                    >
                        Detail Data
                    </ModalHeader>
                    <ModalBody>
                        <form className="w-full max-w-lg">
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        NIK
                                    </label>
                                    <input
                                        value={tiket.SpecTiketData.Nik}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Nama
                                    </label>
                                    <input
                                        value={tiket.SpecTiketData.NamaBagian}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jabatan
                                    </label>
                                    <input
                                        value={tiket.SpecTiketData.Nik}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                                <div className="w-full md:w-1/2 px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Bagian
                                    </label>
                                    <input
                                        value={tiket.SpecTiketData.Nik}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Nama Armada
                                    </label>
                                    <input
                                        value={tiket.SpecTiketData.NamaArmada}
                                        name="NamaArmada"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jenis Tiket
                                    </label>
                                    <input
                                        value={tiket.SpecTiketData.JenisTiket}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jumlah Keberangkatan
                                    </label>
                                    <input
                                        value={tiket.SpecTiketData.JumlahKeberangkatan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Pergi Dari
                                    </label>
                                    <input
                                        value={tiket.SpecTiketData.PergiDari}
                                        name="PergiDari"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                                {tiket.SpecTiketData.JumlahKeberangkatan === "2" && (
                                    <div className="w-full md:w-1/2 px-3 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Pulang Dari
                                        </label>
                                        <input
                                            value={tiket.SpecTiketData.PulangDari}
                                            name="PulangDari"
                                            className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            type="text"
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Keperluan Tiket
                                    </label>
                                    <input
                                        value={tiket.SpecTiketData.KeperluanTiket}
                                        name="KeperluanTiket"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3">
                                <div className="w-full md:w-1/2 px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Keberangakatan
                                    </label>
                                    <DatePicker
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        selected={
                                            new Date(tiket.SpecTiketData.TanggalKeberangakatan)
                                        }
                                    />
                                </div>

                                <div className="w-full md:w-1/2 px-3">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Akhir
                                    </label>
                                    <DatePicker
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        disabled={true}
                                        selected={new Date(tiket.SpecTiketData.TanggalPulang)}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Dewasa
                                    </label>
                                    <div className="inline-block relative w-full  ">
                                        <input
                                            value={tiket.SpecTiketData.Dewasa}
                                            name="Dewasa"
                                            className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            type="number"
                                        />
                                    </div>
                                </div>
                                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Anak
                                    </label>
                                    <div className="inline-block relative w-full  ">
                                        <input
                                            value={tiket.SpecTiketData.Anak}
                                            name="Anak"
                                            className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            type="number"
                                        />
                                    </div>
                                </div>
                                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Bayi
                                    </label>
                                    <div className="inline-block relative w-full  ">
                                        <input
                                            value={tiket.SpecTiketData.Bayi}
                                            name="Bayi"
                                            className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            type="number"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="border-t mb-2 pt-4">Approval</div>
                            <div className="flex flex-wrap -mx-3 mb-4">
                                {
                                    tiket.SpecTiketData.Approval ?
                                        tiket.SpecTiketData.Approval.map((subitemapprov) => (
                                            <div className="w-full md:w-1/2 px-3 mb-6 h-8">
                                                <div
                                                    className="border block rounded border-gray-500 outline-none appearance-none py-3 px-4">
                                                    <div>
                                                        {subitemapprov.NamaBagian} - {subitemapprov.NamaJabatan}
                                                    </div>
                                                    <div>{subitemapprov.Approve}</div>

                                                    {subitemapprov.Approve === "Belum diApprove" ?
                                                        <div>&nbsp;</div>
                                                        :
                                                        <div>{subitemapprov.TanggalApproved}</div>
                                                    }
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div className="w-full px-3">-</div>
                                }
                            </div>
                        </form>
                    </ModalBody>
                </Modal>
            )}
            {resign.isSpecResignSuccess && (
                <Modal
                    size="regular"
                    active={showModalResign}
                    toggler={() => {
                        setShowModalResign(true);
                    }}
                >
                    <ModalHeader
                        className="mt-20"
                        toggler={() => {
                            setShowModalResign(false);
                        }}
                    >
                        Detail Data
                    </ModalHeader>
                    <ModalBody>
                        <form className="w-full max-w-lg">
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        NIK
                                    </label>
                                    <input
                                        value={resign.SpecResignData.Nik}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Nama
                                    </label>
                                    <input
                                        value={resign.SpecResignData.NamaKaryawan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jabatan
                                    </label>
                                    <input
                                        value={resign.SpecResignData.NamaJabatan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                                <div className="w-full md:w-1/2 px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Bagian
                                    </label>
                                    <input
                                        value={resign.SpecResignData.NamaBagian}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Aset Pemilikan Perusahaan
                                    </label>
                                    <input
                                        value={resign.SpecResignData.AsetPemilikanPerusahaan}
                                        name="AsetPemilikanPerusahaan"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Alasan
                                    </label>
                                    <input
                                        value={resign.SpecResignData.Alasan}
                                        name="Alasan"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 ">
                                <div className="w-full px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Pengajuan
                                    </label>
                                    <DatePicker
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        selected={new Date(resign.SpecResignData.TanggalPengajuan)}
                                    />
                                </div>
                            </div>
                            <div className="border-t mb-2 pt-4">Approval</div>
                            <div className="flex flex-wrap -mx-3 mb-4">
                                {
                                    resign.SpecResignData.Approval ?
                                        resign.SpecResignData.Approval.map((subitemapprov) => (
                                            <div className="w-full md:w-1/2 px-3 mb-6 h-8">
                                                <div
                                                    className="border block rounded border-gray-500 outline-none appearance-none py-3 px-4">
                                                    <div>
                                                        {subitemapprov.NamaBagian} - {subitemapprov.NamaJabatan}
                                                    </div>
                                                    <div>{subitemapprov.Approve}</div>

                                                    {subitemapprov.Approve === "Belum diApprove" ?
                                                        <div>&nbsp;</div>
                                                        :
                                                        <div>{subitemapprov.TanggalApproved}</div>
                                                    }
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div className="w-full px-3">-</div>
                                }
                            </div>
                        </form>
                    </ModalBody>
                </Modal>
            )}
            {phk.isSpecPhkSuccess && (
                <Modal
                    size="regular"
                    active={showModalPhk}
                    toggler={() => {
                        setShowModalPhk(true);
                    }}
                >
                    <ModalHeader
                        className="mt-20"
                        toggler={() => {
                            setShowModalPhk(false);
                        }}
                    >
                        Detail Data
                    </ModalHeader>
                    <ModalBody>
                        <form className="w-full max-w-lg">
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        NIK
                                    </label>
                                    <input
                                        value={phk.SpecPhkData.Nik}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Nama
                                    </label>
                                    <input
                                        value={phk.SpecPhkData.NamaKaryawan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jabatan
                                    </label>
                                    <input
                                        value={phk.SpecPhkData.NamaJabatan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                                <div className="w-full md:w-1/2 px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Bagian
                                    </label>
                                    <input
                                        value={phk.SpecPhkData.NamaBagian}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Aset Pemilikan Perusahaan
                                    </label>
                                    <input
                                        value={phk.SpecPhkData.AsetPemilikanPerusahaan}
                                        name="AsetPemilikanPerusahaan"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Alasan
                                    </label>
                                    <input
                                        value={phk.SpecPhkData.Alasan}
                                        name="Alasan"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 ">
                                <div className="w-full px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Pengajuan
                                    </label>
                                    <DatePicker
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        selected={new Date(phk.SpecPhkData.TanggalPengajuan)}
                                    />
                                </div>
                            </div>
                        </form>
                        <div className="border-t mb-2 pt-4">Approval</div>
                        <div className="flex flex-wrap -mx-3 mb-4">
                            {
                                phk.SpecPhkData.Approval ?
                                    phk.SpecPhkData.Approval.map((subitemapprov) => (
                                        <div className="w-full md:w-1/2 px-3 mb-6 h-8">
                                            <div
                                                className="border block rounded border-gray-500 outline-none appearance-none py-3 px-4">
                                                <div>
                                                    {subitemapprov.NamaBagian} - {subitemapprov.NamaJabatan}
                                                </div>
                                                <div>{subitemapprov.Approve}</div>

                                                {subitemapprov.Approve === "Belum diApprove" ?
                                                    <div>&nbsp;</div>
                                                    :
                                                    <div>{subitemapprov.TanggalApproved}</div>
                                                }
                                            </div>
                                        </div>
                                    ))
                                    :
                                    <div className="w-full px-3">-</div>
                            }
                        </div>
                    </ModalBody>
                </Modal>
            )}
            {pelatihan.isSpecPelatihanSuccess && (
                <Modal
                    size="regular"
                    active={showModalPelatihan}
                    toggler={() => {
                        setShowModalPelatihan(true);
                    }}
                >
                    <ModalHeader
                        className="mt-20"
                        toggler={() => {
                            setShowModalPelatihan(false);
                        }}
                    >
                        Detail Data
                    </ModalHeader>
                    <ModalBody>
                        <form className="w-full max-w-lg">
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        NIK
                                    </label>
                                    <input
                                        value={pelatihan.SpecPelatihanData.Nik}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Nama
                                    </label>
                                    <input
                                        value={pelatihan.SpecPelatihanData.NamaKaryawan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jabatan
                                    </label>
                                    <input
                                        value={pelatihan.SpecPelatihanData.NamaJabatan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                                <div className="w-full md:w-1/2 px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Bagian
                                    </label>
                                    <input
                                        value={pelatihan.SpecPelatihanData.NamaBagian}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jenis Pelatihan
                                    </label>
                                    <input
                                        value={pelatihan.SpecPelatihanData.JenisPelatihan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                                <div className="w-full md:w-1/2 px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Topik Pelatihan
                                    </label>
                                    <input
                                        value={pelatihan.SpecPelatihanData.TopikPelatihan}
                                        name="TopikPelatihan"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Materi Pelatihan
                                    </label>
                                    <input
                                        value={pelatihan.SpecPelatihanData.MateriPelatihan}
                                        name="MateriPelatihan"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                                <div className="w-full md:w-1/2 px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Lembaga Pelatihan
                                    </label>
                                    <input
                                        value={pelatihan.SpecPelatihanData.LembagaPelatihan}
                                        name="LembagaPelatihan"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tujuan Pelatihan
                                    </label>
                                    <input
                                        value={pelatihan.SpecPelatihanData.TujuanPelatihan}
                                        name="TujuanPelatihan"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                                <div className="w-full md:w-1/2 px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Biaya Pelatihan
                                    </label>
                                    <input
                                        value={pelatihan.SpecPelatihanData.BiayaPelatihan}
                                        name="BiayaPelatihan"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="number"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tempat Pelaksanaan
                                    </label>
                                    <input
                                        value={pelatihan.SpecPelatihanData.TempatPelaksanaan}
                                        name="TempatPelaksanaan"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-wrap -mx-3">
                                <div className="w-full md:w-1/2 px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Pelaksanaan
                                    </label>
                                    <DatePicker
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        selected={
                                            new Date(pelatihan.SpecPelatihanData.TanggalPelaksanaan)
                                        }
                                    />
                                </div>

                                <div className="w-full md:w-1/2 px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Selesai
                                    </label>
                                    <DatePicker
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        selected={
                                            new Date(pelatihan.SpecPelatihanData.TanggalSelesai)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tiket
                                    </label>
                                    <div className="inline-block relative w-full  ">
                                        <select
                                            value={pelatihan.SpecPelatihanData.Tiket}
                                            name="Tiket"
                                            className={
                                                "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                        >
                                            <option value={0}>Tidak</option>
                                            <option value={1}>Iya</option>
                                        </select>
                                        <div
                                            className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                            <svg
                                                className="fill-current h-4 w-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="border-t mb-2 pt-4">Approval</div>
                            <div className="flex flex-wrap -mx-3 mb-4">
                                {
                                    pelatihan.SpecPelatihanData.Approval ?
                                        pelatihan.SpecPelatihanData.Approval.map((subitemapprov) => (
                                            <div className="w-full md:w-1/2 px-3 mb-6 h-8">
                                                <div
                                                    className="border block rounded border-gray-500 outline-none appearance-none py-3 px-4">
                                                    <div>
                                                        {subitemapprov.NamaBagian} - {subitemapprov.NamaJabatan}
                                                    </div>
                                                    <div>{subitemapprov.Approve}</div>

                                                    {subitemapprov.Approve === "Belum diApprove" ?
                                                        <div>&nbsp;</div>
                                                        :
                                                        <div>{subitemapprov.TanggalApproved}</div>
                                                    }
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div className="w-full px-3">-</div>
                                }
                            </div>
                        </form>
                    </ModalBody>
                </Modal>
            )}
            {lembur.isSpecLemburSuccess && (
                <Modal
                    size="regular"
                    active={showModalLembur}
                    toggler={() => {
                        setShowModalLembur(true);
                    }}
                >
                    <ModalHeader
                        className="mt-20"
                        toggler={() => {
                            setShowModalLembur(false);
                        }}
                    >
                        Detail Data
                    </ModalHeader>
                    <ModalBody>
                        <form className="w-full max-w-lg">
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        NIK
                                    </label>
                                    <input
                                        value={lembur.SpecLemburData.Nik}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Nama
                                    </label>
                                    <input
                                        value={lembur.SpecLemburData.NamaKaryawan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jabatan
                                    </label>
                                    <input
                                        value={lembur.SpecLemburData.NamaJabatan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                                <div className="w-full md:w-1/2 px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Bagian
                                    </label>
                                    <input
                                        value={lembur.SpecLemburData.NamaBagian}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jenis Lembur
                                    </label>
                                    <input
                                        value={lembur.SpecLemburData.JenisLembur}
                                        name="JenisLembur"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Keperluan Lembur
                                    </label>
                                    <input
                                        value={lembur.SpecLemburData.KeperluanLembur}
                                        name="KeperluanLembur"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Pemberi Instruksi Lembur
                                    </label>
                                    <input
                                        value={lembur.SpecLemburData.PemberiIntruksiLembur}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-wrap -mx-3">
                                <div className="w-full md:w-1/2 px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Waktu Mulai
                                    </label>
                                    <DatePicker
                                        showTimeInput
                                        dateFormat="MM/dd/yyyy HH:mm"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        selected={new Date(lembur.SpecLemburData.TanggalMulai)}
                                        disabled={true}
                                    />
                                </div>

                                <div className="w-full md:w-1/2 px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Waktu Akhir
                                    </label>
                                    <DatePicker
                                        showTimeInput
                                        dateFormat="MM/dd/yyyy HH:mm"
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        disabled={true}
                                        selected={new Date(lembur.SpecLemburData.TanggalAkhir)}
                                    />
                                </div>
                            </div>
                            <div className="border-t mb-2 pt-4">Approval</div>
                            <div className="flex flex-wrap -mx-3 mb-4">
                                {
                                    lembur.SpecLemburData.Approval ?
                                        lembur.SpecLemburData.Approval.map((subitemapprov) => (
                                            <div className="w-full md:w-1/2 px-3 mb-6 h-8">
                                                <div
                                                    className="border block rounded border-gray-500 outline-none appearance-none py-3 px-4">
                                                    <div>
                                                        {subitemapprov.NamaBagian} - {subitemapprov.NamaJabatan}
                                                    </div>
                                                    <div>{subitemapprov.Approve}</div>

                                                    {subitemapprov.Approve === "Belum diApprove" ?
                                                        <div>&nbsp;</div>
                                                        :
                                                        <div>{subitemapprov.TanggalApproved}</div>
                                                    }
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div className="w-full px-3">-</div>
                                }
                            </div>
                        </form>
                    </ModalBody>
                </Modal>
            )}
            {izin.isSpecIzinSuccess && (
                <Modal
                    size="regular"
                    active={showModalIzin}
                    toggler={() => {
                        setShowModalIzin(true);
                    }}
                >
                    <ModalHeader
                        className="mt-20"
                        toggler={() => {
                            setShowModalIzin(false);
                        }}
                    >
                        Detail Data
                    </ModalHeader>
                    <ModalBody>
                        <form className="w-full max-w-lg">
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        NIK
                                    </label>
                                    <input
                                        value={izin.SpecIzinData.Nik}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Nama
                                    </label>
                                    <input
                                        value={izin.SpecIzinData.NamaKaryawan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jabatan
                                    </label>
                                    <input
                                        value={izin.SpecIzinData.NamaJabatan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                                <div className="w-full md:w-1/2 px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Bagian
                                    </label>
                                    <input
                                        value={izin.SpecIzinData.NamaJabatan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jenis Izin
                                    </label>
                                    <input
                                        value={izin.SpecIzinData.JenisIzin}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Keperluan Izin
                                    </label>
                                    <input
                                        value={izin.SpecIzinData.KeperluanIzin}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3">
                                <div className="w-full md:w-1/2 px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Mulai
                                    </label>
                                    <DatePicker
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        selected={new Date(izin.SpecIzinData?.TanggalMulai)}
                                    />
                                </div>

                                <div className="w-full md:w-1/2 px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Akhir
                                    </label>
                                    <DatePicker
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        selected={new Date(izin.SpecIzinData.TanggalAkhir)}
                                    />
                                </div>
                            </div>
                            <div className="border-t mb-2 pt-4">Approval</div>
                            <div className="flex flex-wrap -mx-3 mb-4">
                                {
                                    izin.SpecIzinData.Approval ?
                                        izin.SpecIzinData.Approval.map((subitemapprov) => (
                                            <div className="w-full md:w-1/2 px-3 mb-6 h-8">
                                                <div
                                                    className="border block rounded border-gray-500 outline-none appearance-none py-3 px-4">
                                                    <div>
                                                        {subitemapprov.NamaBagian} - {subitemapprov.NamaJabatan}
                                                    </div>
                                                    <div>{subitemapprov.Approve}</div>

                                                    {subitemapprov.Approve === "Belum diApprove" ?
                                                        <div>&nbsp;</div>
                                                        :
                                                        <div>{subitemapprov.TanggalApproved}</div>
                                                    }
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div className="w-full px-3">-</div>
                                }
                            </div>
                        </form>
                    </ModalBody>
                </Modal>
            )}
            {claimPengobatan.isSpecClaimPengobatanSuccess && (
                <Modal
                    size="regular"
                    active={showModalClaimPengobatan}
                    toggler={() => {
                        setShowModalClaimPengobatan(true);
                    }}
                >
                    <ModalHeader
                        className="mt-20"
                        toggler={() => {
                            setShowModalClaimPengobatan(false);
                        }}
                    >
                        Detail Data
                    </ModalHeader>
                    <ModalBody>
                        <form className="w-full max-w-lg">
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        NIK
                                    </label>
                                    <input
                                        value={claimPengobatan.SpecClaimPengobatanData.Nik}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Nama
                                    </label>
                                    <input
                                        value={claimPengobatan.SpecClaimPengobatanData.NamaKaryawan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jabatan
                                    </label>
                                    <input
                                        value={claimPengobatan.SpecClaimPengobatanData.NamaJabatan}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                                <div className="w-full md:w-1/2 px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Bagian
                                    </label>
                                    <input
                                        value={claimPengobatan.SpecClaimPengobatanData.NamaBagian}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Rumah Sakit / Klinik
                                    </label>
                                    <input
                                        value={
                                            claimPengobatan.SpecClaimPengobatanData.NamaRumahSakit
                                        }
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jenis Rawat
                                    </label>
                                    <input
                                        value={claimPengobatan.SpecClaimPengobatanData.JenisRawat}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jenis Pengobatan
                                    </label>
                                    <input
                                        value={
                                            claimPengobatan.SpecClaimPengobatanData.JenisPengobatan
                                        }
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 ">
                                <div className="w-full md:w-1/2 px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Mulai
                                    </label>
                                    <DatePicker
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        selected={
                                            new Date(
                                                claimPengobatan.SpecClaimPengobatanData.TanggalSakit
                                            )
                                        }
                                    />
                                </div>

                                <div className="w-full md:w-1/2 px-3 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Tanggal Akhir
                                    </label>
                                    <DatePicker
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        selected={
                                            new Date(
                                                claimPengobatan.SpecClaimPengobatanData.TanggalSelesai
                                            )
                                        }
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Nama Dokter
                                    </label>
                                    <input
                                        value={claimPengobatan.SpecClaimPengobatanData.NamaDokter}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jenis Obat
                                    </label>
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Biaya Dokter
                                    </label>
                                    <input
                                        value={claimPengobatan.SpecClaimPengobatanData.BiayaDokter}
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Total Biaya Obat
                                    </label>
                                    <input
                                        value={
                                            claimPengobatan.SpecClaimPengobatanData.TotalBiayaObat
                                        }
                                        disabled
                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="border-t mb-2 pt-4">Approval</div>
                            <div className="flex flex-wrap -mx-3 mb-4">
                                {
                                    claimPengobatan.SpecClaimPengobatanData.Approval ?
                                        claimPengobatan.SpecClaimPengobatanData.Approval.map((subitemapprov) => (
                                            <div className="w-full md:w-1/2 px-3 mb-6 h-8">
                                                <div
                                                    className="border block rounded border-gray-500 outline-none appearance-none py-3 px-4">
                                                    <div>
                                                        {subitemapprov.NamaBagian} - {subitemapprov.NamaJabatan}
                                                    </div>
                                                    <div>{subitemapprov.Approve}</div>

                                                    {subitemapprov.Approve === "Belum diApprove" ?
                                                        <div>&nbsp;</div>
                                                        :
                                                        <div>{subitemapprov.TanggalApproved}</div>
                                                    }
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div className="w-full px-3">-</div>
                                }
                            </div>
                        </form>
                    </ModalBody>
                </Modal>
            )}
        </div>
    );
};

export default MonitoringPage;
